export default "__VITE_ASSET__a2d24c24__"